import antd from 'ant-design-vue/es/locale-provider/tr_TR';
import dayjsLocale from 'dayjs/locale/tr';
import momentEnCA from 'moment/dist/locale/en-ca';
import data from '../json/tr.json';

const components = {
  antLocale: antd,
  momentName: 'eu',
  momentLocale: momentEnCA,
  dayjsName: 'tr',
  dayjsLocale
};
export default {
  ...components,
  ...data
};
